import React from 'react'

export const Applications = () => <path d='M18 20V10M12 20V4M6 20V14' />
